export enum ARTICLE {
  SHOW = '/articles/show/:id',
  RESULTS = '/articles/results',
}
